let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6IDv4")).then(() => parcelRequire('64Fy9'));